import { normalize } from 'utilities/math';
import { LayoutFactory } from './layout_factory';

export class BaseLayout {
    constructor(config) {
        this.config         = config;
        this.root           = config.root;
        this.name           = config.name;
        this.aspect         = config.aspect;
        this.width          = config.width;
        this.height         = config.height;
        this.left           = config.left;
        this.top            = config.top;

        this.children       = config.children.map(LayoutFactory.create);
        this.orientation    = config.direction || 'vertical';
        this.physicalWidth  = config.physicalWidth;
        this.physicalHeight = config.physicalHeight || config.aspect ? normalize(config.aspect) * config.physicalWidth : undefined;

        this.computeLayout();
    }

    // intended to be overridden by children
    computeLayout() {}

    serialize(adjustments) {
        const { left, top, width, height, maxPhysicalWidth, maxPhysicalHeight } = adjustments,
            col = isNaN(left)   ? this.left   : left         + this.left,
            row = isNaN(top)    ? this.top    : top          + this.top,
            w   = isNaN(width)  ? this.width  : normalize(width)  * this.width,
            h   = isNaN(height) ? this.height : normalize(height) * this.height,
            basePhysicalWidth  = this.physicalWidth,
            basePhysicalHeight = this.physicalHeight;

        const serialized = {
            name: this.name,
            root: this.root,
            col,
            row,
            w,
            h,
            basePhysicalWidth,
            basePhysicalHeight,
            maxPhysicalWidth,
            maxPhysicalHeight
        };

        if (this.aspect) {
            serialized.aspect = this.aspect;
        }

        return serialized;
    }
}